import { AccountingPeriodBody } from '@modules/accounting-and-finance/interface/accounting-period/accounting-period-interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: AccountingPeriodBody[] = [];

export const ACCGAccountingPeriodSlice = createSlice({
  name: 'accgAccountingPeriod',
  initialState,
  reducers: {
    setACCGAccountingPeriod: (
      _state,
      action: PayloadAction<AccountingPeriodBody[]>,
    ) => {
      return [...action.payload];
    },
    removeACCGAccountingPeriod: () => {
      return initialState;
    },
  },
});

export default ACCGAccountingPeriodSlice.reducer;

export const { setACCGAccountingPeriod, removeACCGAccountingPeriod } =
  ACCGAccountingPeriodSlice.actions;
